/* Elemence Standards — generates radial tick marks on the QC seal SVG.
   60 ticks every 6°, every 5th tick is "major" (longer). Scoped per
   section so multiple instances on a page don't collide. */
(function () {
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const CX = 240;
  const CY = 280;

  function buildTicks(group) {
    if (!group || group.dataset.built === '1') return;
    group.dataset.built = '1';

    for (let i = 0; i < 60; i++) {
      const deg = i * 6;
      const rad = (deg * Math.PI) / 180;
      const major = i % 5 === 0;
      const r1 = major ? 206 : 212;
      const r2 = 220;
      const x1 = CX + Math.cos(rad) * r1;
      const y1 = CY + Math.sin(rad) * r1;
      const x2 = CX + Math.cos(rad) * r2;
      const y2 = CY + Math.sin(rad) * r2;
      const line = document.createElementNS(SVG_NS, 'line');
      line.setAttribute('x1', x1);
      line.setAttribute('y1', y1);
      line.setAttribute('x2', x2);
      line.setAttribute('y2', y2);
      line.setAttribute('stroke', major ? 'rgba(232,217,207,0.95)' : 'rgba(232,217,207,0.45)');
      line.setAttribute('stroke-width', major ? '1.6' : '1.05');
      line.setAttribute('stroke-linecap', 'round');
      group.appendChild(line);
    }
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.elemence-standards__ticks').forEach(buildTicks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
